var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-h rPos"},[_c('mymenu',{staticStyle:{"position":"relative","left":"0px","width":"100%"},attrs:{"id":"__mykeepmenu__","keepalive":"","xxxyyy":"","inputstyle":"box-shadow:rgba(128, 128, 128, 0.62) 1px 1px 3px 1px;height:40px;"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1d86594","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.Homepage.Closemenu.vue
// module id = null
// module chunks = 